<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Create ticket</h3>
    <p class="modal-subtitle mb-0">
      Opens a new Zendesk follow-up for this vendor.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<form class="modal-body" [formGroup]="TicketForm">
  <div class="form-group">
    <label class="form-label" requiredAsterisk for="ct-subject">Subject</label>
    <input
      id="ct-subject"
      class="form-control"
      type="text"
      formControlName="subject"
      placeholder="What's the ticket about?"
    />
  </div>

  <div class="form-group mb-0">
    <label class="form-label" for="ct-description">Description</label>
    <textarea
      id="ct-description"
      class="form-control ct-description"
      formControlName="description"
      rows="6"
      placeholder="Add any details the Zendesk agent should know — context, history, links."
    ></textarea>
  </div>
</form>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="create()">
      Create ticket
    </button>
  </div>
</div>
